enum Routes {
  TEAM = '/team',
  MATCHES = '/matches',
}

export default Routes
